// extracted by mini-css-extract-plugin
module.exports =  {"img":"_9400a595a7--img--Shiy6","square":"_9400a595a7--square--Lqv7Q","circle":"_9400a595a7--circle--u4Haq"};